module.exports = __webpack_public_path__ + "static/media/btcz.ff60f175.svg";